import axios from "axios";
import Constants from "./Constants";
import fire from './Toastr';
import { ensureTenantId } from './tenantHelper';

export default async function APICall(
  Url,
  Method,
  Data = null,
  timeoutOverride,
  silent,
) {
  // Check if this is not the admin login endpoint
  const isAdminLogin = Url.includes('/api/User/admin/login');
  
  // Validate tenantId for all endpoints except admin login
  if (!isAdminLogin) {
    let tenantId = sessionStorage.getItem("tenantId");
    if (!tenantId) {
      // Try to regenerate tenantId before failing
      tenantId = await ensureTenantId();
      if (!tenantId) {
        if (!silent) {
          fire("error", "Session expired. Please log in again.");
        }
        // Clear session and redirect to login
        sessionStorage.clear();
        window.location.href = "/";
        return null;
      }
    }
  }

  if(sessionStorage){
    if (sessionStorage.getItem("token")) {
      const authToken = sessionStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
      axios.defaults.headers.common["Content-Type"] = `application/json`;
      
    }
     if(sessionStorage.getItem("tenantId")){
    const tenant = sessionStorage.getItem("tenantId");
    console.log("axios tenant", tenant);
    axios.defaults.headers.common["tenant"] = `${tenant}`;
    axios.defaults.headers.common["Content-Type"] = `application/json`;
  }
  }
  if(sessionStorage){
    if (sessionStorage.getItem("token")) {
      const authToken = sessionStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
      axios.defaults.headers.common["Content-Type"] = `application/json`;
    }
  }

  axios.defaults.withCredentials = true;
  axios.interceptors.response.use(
    (response) => {
     
      if (response?.data?.authorization) {       
        sessionStorage.setItem("token", response.data.authorization);
      }
      return response;
    },
    (error) => {
      return error.response;
    }
  );


  let baseUrl = Constants.apiBaseUrl;
  // if (!baseUrl.endsWith("/")) {
  //   baseUrl = baseUrl + "/";
  // }

  // if (Url.startsWith("/")) {
  //   Url = Url.substring(1);
  // }

  let response = await axios({
    method: Method,
    url: baseUrl + Url.trim(),
    data: Data,
    timeout: timeoutOverride || process.env.REACT_APP_REQUEST_TIMEOUT,   
  });

  if (response) {
    if (!response.status || response.status === 0) {
      if (!silent)
        fire(
          "error",
          "Sorry it seems you are not connected to internet. Please check you network connection and try again"
        );
      return null;
    }
    if (response.status === 401 || response.statusText === "Unauthorized") {
      sessionStorage.clear();
      window.location.href = "/";
      return null;
    }
    if (response.status >= 400 && response.status < 500) {
      let message =
        "Sorry your request is invalid. please check your request and try again";
      if (response.data) {
        if (response.data.message) {
          message = `${response.data.message}`;
        } else {
          message = response.data;
        }
      }
      if (!silent) fire("warning", message);
      return null;
    }
    if (response.status >= 500) {
      let message =
        "Sorry your request cannot be processed at this moment please try again later";
      if (response.data) {
        message = `${response.data.message}`;
      }
      if (!silent) fire("error", message);
      return null;
    }
  } else {
    if (!silent) {
      fire(
        "error",
        "Your request generated an error. Please check your network connection"
      );
    }
  }

  return !response
    ? null
    : response.data
    ? response.data
    : { status: "success" };
}
